import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';

var IconSearch = /*#__PURE__*/function (_React$Component) {
  _inherits(IconSearch, _React$Component);

  var _super = _createSuper(IconSearch);

  function IconSearch(props) {
    _classCallCheck(this, IconSearch);

    return _super.call(this, props);
  }

  _createClass(IconSearch, [{
    key: "render",
    value: function render() {
      var isServerRendering = function () {
        try {
          return !((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && document !== undefined);
        } catch (e) {
          return true;
        }
      }();

      var prefixCls = !isServerRendering && window.BYTEUI_PREFIXCLS ? window.BYTEUI_PREFIXCLS : this.props.prefixCls;
      var className = this.props && this.props.className ? this.props.className + ' ' : '';

      var props = _objectSpread({}, this.props, {
        className: className + 'byte-icon byte-icon-search'.replace(/byte-/g, prefixCls + '-')
      });

      if (this.props.spin) {
        props.className = props.className + ' ' + prefixCls + '-icon-loading';
      }

      delete props.prefixCls;
      delete props.spin;
      delete props.isIcon;
      return /*#__PURE__*/React.createElement("svg", _extends({
        className: "byte-icon byte-icon-search",
        viewBox: "0 0 1024 1024",
        width: "1em",
        height: "1em",
        fill: "currentColor"
      }, props), /*#__PURE__*/React.createElement("path", {
        d: "M819.2 718.165l154.283 154.283a23.21 23.21 0 010 32.768l-38.912 38.23a22.528 22.528 0 01-32.086 0L750.933 793.258a386.39 386.39 0 1168.267-75.094zm-318.805 73.728a291.499 291.499 0 10-290.816-291.498 291.499 291.499 0 00290.816 291.498z"
      }));
    }
  }]);

  return IconSearch;
}(React.Component);

IconSearch.defaultProps = {
  isIcon: true,
  prefixCls: 'byte'
};
export default IconSearch;